// extracted by mini-css-extract-plugin
export default {"form":"Form_form__eRb0W","notvisible":"Form_notvisible__Hxxpn","thanks":"Form_thanks__7wlO7"};